import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  ActionIconButton,
  PaginationTable,
  NoDataSkeleton,
  StatusChip,
} from '../../../common/components';

const MovementTypesDataTable = ({
  movementTypes,
  totalMovementTypes,
  page,
  totalPages,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDelete,
  isLoading,
  LoadingComponent,
}) => {
  const getNatureChip = (nature) => {
    if (nature === 'debit') {
      return <StatusChip label="Débito" color="error" />;
    }
    if (nature === 'credit') {
      return <StatusChip label="Crédito" color="success" />;
    }
    return <StatusChip label={nature} />;
  };


  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <GeneralTableBox>
      <Table stickyHeader>
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                py: { xs: 1, md: 1.5 },
              },
            }}
          >
            <HeadTableCell>Descripción</HeadTableCell>
            <HeadTableCell>Naturaleza</HeadTableCell>
            <HeadTableCell>Órdenes</HeadTableCell>
            <HeadTableCell>Mov. Bancarios</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {movementTypes && movementTypes.length > 0 ? (
            movementTypes.map((movementType) => (
              <TableRow
                key={movementType.uuid}
                sx={{
                  '& td': {
                    py: { xs: 0.75, md: 1 },
                  },
                }}
              >
                <RowTableCell>{movementType.description}</RowTableCell>
                <RowTableCell>{getNatureChip(movementType.nature)}</RowTableCell>
                <RowTableCell>
                  {movementType.display_in_orders ? (
                    <StatusChip label="Disponible" color="success" />
                  ) : (
                    <StatusChip label="Oculto" color="warning" />
                  )}
                </RowTableCell>
                <RowTableCell>
                  {movementType.is_bank_movement_type ? (
                    <StatusChip label="Si" color="info" />
                  ) : (
                    <StatusChip label="No" color="default" />
                  )}
                </RowTableCell>
                <RowTableCell>
                  <ActionIconButton variant="edit" onClick={() => onEdit(movementType)} />
                  <ActionIconButton
                    variant="delete"
                    onClick={() => onDelete(movementType)}
                    disabled={!movementType.is_active}
                  />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton message="No se encontraron tipos de movimiento" />
          )}
        </TableBody>
      </Table>

      {totalMovementTypes > rowsPerPage && (
        <PaginationTable
          page={page}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          totalCount={totalMovementTypes}
        />
      )}
    </GeneralTableBox>
  );
};

export default MovementTypesDataTable;
